module.exports = __webpack_public_path__ + "static/Sohom-0357ef9404d8520967ee99977e55aded.jpg";